/**
 * Utility functions for extracting components from metric data
 * based on scoreDimensionMetadata flags
 */

/**
 * Extracts the main/aggregated component from a list of components
 * @param {Array<any>} components - Array of metric components
 * @returns {any} The main component or undefined if not found
 */
export const getMainComponent = (components) => {
  if (!components || !Array.isArray(components) || components.length === 0) {
    return undefined;
  }

  // Try to find component marked as main (multi-dimension questionnaires)
  const mainComp = components.find(c => c?.scoreDimensionMetadata?.isMainComponent);

  // Fallback to first component (handles numeric/scale/choice single-component metrics)
  return mainComp || components[0];
};

/**
 * Extracts dimension components (non-main) from a list of components
 * @param {Array<any>} components - Array of metric components
 * @returns {Array<any>} Array of dimension components (empty array if none found)
 */
export const getDimensionComponents = (components) => {
  if (!components || !Array.isArray(components) || components.length === 0) {
    return [];
  }

  return components.filter(c => !c?.scoreDimensionMetadata?.isMainComponent);
};
